module.exports = __webpack_public_path__ + "static/media/2.155e1784.png";